export type GetAccessToken = () => string | null | Promise<string | null>;

export type ChatRuntime = {
  baseUrl: string;
  getAccessToken?: GetAccessToken;
  fetchImpl?: typeof fetch;
  resolveFileUrl: (value: string | null) => string | null;
};

function trimTrailingSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

export function createChatRuntime(getAccessToken?: GetAccessToken): ChatRuntime {
  const baseUrl = import.meta.env.VITE_API_URL;

  if (!baseUrl) {
    throw new Error('VITE_API_URL is required for Chat feature');
  }

  const normalizedBaseUrl = trimTrailingSlash(baseUrl);

  return {
    baseUrl: normalizedBaseUrl,
    getAccessToken,
    resolveFileUrl: (value) => {
      if (!value) return null;
      if (/^https?:\/\//i.test(value)) return value;
      return `${normalizedBaseUrl}${value.startsWith('/') ? value : `/${value}`}`;
    },
  };
}
